import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import userApi, { AccountType } from '../../api/userApi';

export const NAMESPACE = 'account';

export interface AccountState {
  accountType: AccountType | null;
  desiredCreditsAmount: number;
}

const initialState: AccountState = {
  accountType: null,
  desiredCreditsAmount: 1000,
};

const accountStoreSlice = createSlice({
  name: NAMESPACE,
  initialState,
  reducers: {
    setDesiredCreditsAmount: (state, { payload }: PayloadAction<number>) => {
      state.desiredCreditsAmount = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      userApi.endpoints.getUserInfo.matchFulfilled,
      (state, { payload }) => {
        const {
          apiSettings: { status },
        } = payload;
        state.accountType = status;
      }
    );
  },
});

export const { actions, reducer } = accountStoreSlice;
